import { useMemo } from "react";

import { formatDate } from "base/utils";
import { DATA_TYPES } from "base/constants";

const getLocale = () => {
  let currentUser = window.accountDetails.UserDetails;
  let { AccountDetails } = currentUser;
  let localeDateFormat =
    currentUser.DateFormat === "LOCAL"
      ? AccountDetails.DateFormat
      : currentUser.DateFormat;
  return localeDateFormat;
};

const useChartDataset = (data, cols, vals = []) => {
  if (!data.length) {
    data = [{}];
  }

  const collectionOfKeys = useMemo(
    function getCollectionKeys() {
      return data.map((elem, index) => {
        return Object.keys(elem);
      });
    },
    [data]
  );

  const labels = useMemo(
    function getLabels() {
      const maxKeysData = data.reduce((max, value) => {
        return max.concat(Object.keys(value));
      }, []);
      return maxKeysData
        ? maxKeysData.filter((keys) => {
            return keys !== cols[0]?.Id;
          })
        : [];
    },
    [cols, data]
  );

  const uniqueLabels = useMemo(
    function getUniqueLabels() {
      let uLabels = labels.filter((c, index) => {
        return labels.indexOf(c) === index;
      });

      collectionOfKeys.flat().forEach((c) => {
        if (!uLabels.includes(c) && c !== cols[cols.length - 1]?.Id) {
          uLabels.push(c);
        }
      });

      return uLabels;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [labels]
  );

  let Values = useMemo(
    function getValues() {
      return data.map((d) => {
        return uniqueLabels.map((a) => {
          return d[a] ?? "Other";
        });
      });
    },
    [data, uniqueLabels]
  );

  const xAxisLabel = useMemo(
    function getXAxisLabel() {
      return data.map((elem, i) => {
        let data = elem[cols[0]?.Id];
        if (
          !cols.isEmpty() &&
          cols[0].Type === DATA_TYPES.DATE_TIME &&
          cols[0].ProjectionFunction === "DATE" &&
          data !== "Other"
        ) {
          data = formatDate(data, getLocale()).replaceAll("/", "-");
        }
        return data?.toString();
      });
    },
    [cols, data]
  );

  return {
    labels: uniqueLabels,
    xAxisLabel: xAxisLabel,
    vals,
    cols,
    data,
    series: Values
  };
};

export { useChartDataset };
